var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0146484H24V23.7485H0V0.0146484Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_184)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.0146484C5.37 0.0146484 0 5.32509 0 11.8816C0 17.1327 3.435 21.5679 8.205 23.1403C8.805 23.2441 9.03 22.8881 9.03 22.5766C9.03 22.2948 9.015 21.3603 9.015 20.3664C6 20.9152 5.22 19.6396 4.98 18.972C4.845 18.6309 4.26 17.5777 3.75 17.2958C3.33 17.0733 2.73 16.5245 3.735 16.5097C4.68 16.4948 5.355 17.37 5.58 17.726C6.66 19.5209 8.385 19.0165 9.075 18.705C9.18 17.9337 9.495 17.4145 9.84 17.1178C7.17 16.8212 4.38 15.7976 4.38 11.2585C4.38 9.96802 4.845 8.9 5.61 8.06932C5.49 7.77264 5.07 6.55628 5.73 4.92458C5.73 4.92458 6.735 4.61308 9.03 6.14094C9.99 5.87394 11.01 5.74043 12.03 5.74043C13.05 5.74043 14.07 5.87394 15.03 6.14094C17.325 4.59824 18.33 4.92458 18.33 4.92458C18.99 6.55628 18.57 7.77264 18.45 8.06932C19.215 8.9 19.68 9.95319 19.68 11.2585C19.68 15.8125 16.875 16.8212 14.205 17.1178C14.64 17.4887 15.015 18.2007 15.015 19.3132C15.015 20.9004 15 22.1761 15 22.5766C15 22.8881 15.225 23.259 15.825 23.1403C18.2072 22.3449 20.2772 20.8309 21.7437 18.8112C23.2101 16.7915 23.9993 14.368 24 11.8816C24 5.32509 18.63 0.0146484 12 0.0146484Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.27b83187abea43432eb646c5781b43ea.svg";
export { ForwardRef as ReactComponent };